import React, { Component } from 'react';
import PropTypes from 'prop-types';
import YouTube from 'react-youtube';

export const YouTubeVideoDossier = props => {
  return (
    <section>
      <div className="row">
        <div className="col-lg-12">
          <div className="full-width">
            <div className="iframe-wrap iframe-16-9">
              <YouTube videoId={props.content.fieldVideoYoutube.videoId} />
            </div>
          </div>
        </div>
      </div>

    </section>
  );
};

YouTubeVideoDossier.propTypes = {
  content: PropTypes.object.isRequired,
};
